import { createGlobalStyle } from "styled-components"

export const GlobalStyle = createGlobalStyle`
/* Box sizing rules */
*,
*::before,
*::after {
  box-sizing: border-box;
}

*{
  font-family: ${props => props.theme.font};
}

/* http://meyerweb.com/eric/tools/css/reset/ 
   v2.0 | 20110126
   License: none (public domain)
*/

html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
    font-family: ${props => props.theme.font};
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;  
    vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure, 
footer, header, hgroup, menu, nav, section {
    display: block;
}
body {
    line-height: 1;
}
a {
  cursor: pointer;
}
ol, ul {
    list-style: none;
}
blockquote, q {
    quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
    content: '';
    content: none;
}
table {
    border-collapse: collapse;
    border-spacing: 0;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

.rolagemAzul::-webkit-scrollbar {
  margin-right: 5px;
  width: 9px;
}

.rolagemAzul::-webkit-scrollbar-track {
  border: 1px solid #eee;
  border-radius: 5px;
}

.rolagemAzul::-webkit-scrollbar-thumb {
  background: #2991D6;
  border-radius: 5px;
}

.custom-scroll::-webkit-scrollbar {
  width: 6px !important;
}

.custom-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.custom-scroll::-webkit-scrollbar-thumb {
  background: #d4d4d4;
  border-radius: 999px;
}

.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: #bdbdbd;
}

.custom-scroll::-webkit-scrollbar-button {
  display: none !important;
  width: 0;
  height: 0;
}

`
